import { CircularProgress } from '@mui/material';
import MuiBackdrop from '@mui/material/Backdrop';

import useAppLoading from 'src/stores/loading';

export function LoadingOverlay() {
    const { isAppLoading } = useAppLoading();
    return (
        <MuiBackdrop
            open={isAppLoading}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer - 1,
            }}
        >
            {isAppLoading && <CircularProgress color="inherit" />}
        </MuiBackdrop>
    );
}